// extracted by mini-css-extract-plugin
export default {"breadcrumbsMultiItemsContainer":"IMVVWC"};